export default function Testimonials() {
  const testimonials = [
    {
      name: "김민수",
      position: "안전관리자",
      company: "○○건설",
      content: "급하게 요청했는데 상담도 친절하게 해주시고 빠르게 진행했습니다. 감사합니다.",
      rating: 5,
      image: "https://public.readdy.ai/ai/img_res/e20454e469d438e25fb2415e46e515d6.jpg"
    },
    {
      name: "이지은",
      position: "보건관리자",
      company: "○○제조",
      content: "견적 받았던 곳들 중에 가격도 제일 저렴하고 퀄리티도 좋아서 다른 서류도 맡겨볼 예정이에요.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Korean%20female%20health%20manager%20in%20business%20attire%20smiling%20warmly%20in%20modern%20office%20setting%2C%20corporate%20headshot%20style%2C%20natural%20lighting%2C%20clean%20background%2C%20professional%20business%20portrait%20photography%2C%20realistic%20Korean%20businesswoman%20in%20her%2030s&width=400&height=400&seq=testimonial-person-002&orientation=squarish"
    },
    {
      name: "박준호",
      position: "안전보건관리책임자",
      company: "○○물류",
      content: "서류를 컨설팅으로 맡기니까 실무를 좀 편하게 볼 수 있어요. 전문가에게 맡기길 잘했습니다.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Korean%20male%20safety%20director%20in%20formal%20business%20suit%20smiling%20professionally%20in%20modern%20corporate%20office%2C%20executive%20headshot%20style%2C%20natural%20lighting%2C%20clean%20background%2C%20professional%20business%20portrait%20photography%2C%20realistic%20Korean%20executive%20in%20his%2050s&width=400&height=400&seq=testimonial-person-003&orientation=squarish"
    },
    {
      name: "최수진",
      position: "관리감독자",
      company: "○○화학",
      content: "감독 대응까지 꼼꼼하게 챙겨주셔서 안심하고 진행할 수 있었습니다. 추천합니다!",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Korean%20female%20supervisor%20in%20business%20blazer%20smiling%20confidently%20in%20modern%20industrial%20office%2C%20corporate%20headshot%20style%2C%20natural%20lighting%2C%20clean%20background%2C%20professional%20business%20portrait%20photography%2C%20realistic%20Korean%20businesswoman%20in%20her%2040s&width=400&height=400&seq=testimonial-person-004&orientation=squarish"
    },
    {
      name: "정태영",
      position: "안전관리자",
      company: "○○식품",
      content: "처음 컨설팅 받아보는데 과정 설명도 자세히 해주시고 결과물도 만족스럽습니다.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Korean%20male%20safety%20coordinator%20in%20business%20casual%20attire%20smiling%20warmly%20in%20modern%20office%20environment%2C%20corporate%20headshot%20style%2C%20natural%20lighting%2C%20clean%20background%2C%20professional%20business%20portrait%20photography%2C%20realistic%20Korean%20businessman%20in%20his%2030s&width=400&height=400&seq=testimonial-person-005&orientation=squarish"
    },
    {
      name: "한서연",
      position: "보건관리자",
      company: "○○전자",
      content: "사후관리까지 책임지고 해주셔서 정말 든든했습니다. 다음에도 꼭 이용하겠습니다.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Korean%20female%20health%20coordinator%20in%20business%20attire%20smiling%20professionally%20in%20modern%20tech%20office%2C%20corporate%20headshot%20style%2C%20natural%20lighting%2C%20clean%20background%2C%20professional%20business%20portrait%20photography%2C%20realistic%20Korean%20businesswoman%20in%20her%2030s&width=400&height=400&seq=testimonial-person-006&orientation=squarish"
    }
  ];

  return (
    <section id="testimonials" className="py-12 md:py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-4 md:mb-6">
            생생한 고객 후기
          </h2>
          <p className="text-base md:text-xl text-slate-600 max-w-3xl mx-auto">
            실제 고객들의 경험을 확인해보세요
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-200">
              <div className="flex items-center mb-4 md:mb-6">
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden mr-3 md:mr-4 flex-shrink-0">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="text-base md:text-lg font-bold text-slate-900">{testimonial.name}</h4>
                  <p className="text-xs md:text-sm text-slate-600">{testimonial.position}</p>
                  <p className="text-xs text-slate-500">{testimonial.company}</p>
                </div>
              </div>

              <div className="flex mb-3 md:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-base md:text-lg"></i>
                ))}
              </div>

              <p className="text-slate-700 text-xs md:text-sm leading-relaxed">
                "{testimonial.content}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
